module.exports = __webpack_public_path__ + "zvetseni-prsou_42_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_42_after.jpg
// module id = 1337
// module chunks = 0